function swap(image) {
	"use strict";
    var widthwindow1 = $(window).width();    
    document.getElementById("image").src = image.href;
    if(widthwindow1 >= 1024){
	    $('#image').elevateZoom({
	        zoomType: "inner",
	        cursor: "crosshair",
	        zoomWindowFadeIn: 375,
	        zoomWindowFadeOut: 375
	    });
    };
}; 
$(document).ready(function() {
  	
  
  	var stickypaddingtop = $('.header-top').offset().top;
  	var stickymenu = function(){
  		var scrolltop = $(window).scrollTop();
      	var scrolltopmenu1 = stickypaddingtop + 200;
      	var scrolltopmenu2 = stickypaddingtop + 400;
      	$('.header-top').addClass('hanimation');
      	if ( scrolltop > scrolltopmenu2 ){
            $('.header-top').addClass('sticky-menu');
            $('.header-top').removeClass('animation-sticky-up');
          	$('.header-top').addClass('animation-sticky-down');
        } else if ( scrolltopmenu1 < scrolltop && scrolltop <= scrolltopmenu2 ){
        	$('.header-top').removeClass('animation-sticky-down');
            $('.header-top').addClass('animation-sticky-up');
        } else if ( scrolltop < scrolltopmenu1 ){
        	$('.header-top').removeClass('animation-sticky-up');
            $('.header-top').removeClass('sticky-menu');
        }
  	};
  
  	$(window).scroll(function() {
      stickymenu();
    });
   
  
	"use strict";
	if ($(".ver-2 .tp-banner").length) {
		$('.ver-2 .tp-banner').revolution(
		{
			delay:9000,
			startwidth:1800,
			startheight:650,
			hideThumbs:10,
			fullWidth:"on",
			forceFullWidth:"on"
		});
	};
	if($(".slider-v2 .tp-banner").length > 0) {
		revolutionSlider_4();
	}
  
  
     $('.section-slider-v2 .tp-rightarrow').click(function( e ){
        jQuery('.slider-v2 .tp-banner').revnext();
     });
  	$('.section-slider-v2 .tp-leftarrow').click(function( e ){
        jQuery('.slider-v2 .tp-banner').revprev();
     });
	
	if ($(".product-img-box #image-view").length) {
	    var widthwindow1 = $(window).width();
	    if(widthwindow1 >= 1024){
		    $('#image').elevateZoom({
		        zoomType: "inner",
		        cursor: "crosshair",
		        zoomWindowFadeIn: 375,
		        zoomWindowFadeOut: 375
		    });
	    };
    };
	// Tabs
	$(".tab-content").hide();
	$(".tab-content:first").show(); 
	$("ul.tabs li:first").addClass("active");
	$("ul.tabs li").click(function() {
		$("ul.tabs li").removeClass("active");
		$(this).addClass("active");
		$(".tab-content").hide();
		var activeTab = $(this).attr("rel");
		$("#"+activeTab).fadeIn(); 
	});	
	// End tabs

	// Slider Products
	var owl = $(".product-tab-content");
	$(window).on("orientationchange load resize",function() {
		owl.css({"width": $(".container").width()+24 +"px"});
	});
	owl.css({"width": $(".container").width()+24 +"px"});

	var owl1 = $(".blog-post-inner");
	$(window).on("orientationchange load resize",function() {
		owl1.css({"width": $(".container").width()+20 +"px"});
	});
	owl1.css({"width": $(".container").width()+20 +"px"});

	owl.owlCarousel({
		  navigation : true, // Show next and prev buttons   
	      slideSpeed : 500,
	      singleItem:true,
	      pagination : true,
	      loop:true,
	      responsiveClass:true,
	      responsive:{
	        0:{
	          items:1 
	        },

	        480:{
	          items:2,
	          
	        },

	        767:{
	          items:3,
	        },

	       	1025:{
	          items:4,
	        }
	      }
	});
	// End Slider Products
	$(".blog-post-inner").owlCarousel({
		  navigation : true, // Show next and prev buttons   
	      slideSpeed : 500,
	      singleItem:true,
	      pagination : true,
	      loop:true,
	      responsiveClass:true,
	      responsive:{
	        0:{
	          items:1 
	        },

	        480:{
	          items:2,
	          
	        },

	        767:{
	          items:2,
	        },

	        1025:{
	          items:3,
	        }
	      }
	});

	// Add Class dropdown-menu
	var menu_top_header3 = $(".header-v3 .menu-top");
	$(window).on("orientationchange load resize",function() {
		var widthwindow = $(window).width();
		if(widthwindow > 1024){
			$(".ver-2 .forcefullwidth_wrapper_tp_banner").after($(".mega-menu.mega-menu-v2 "));
			menu_top_header3.insertAfter($(".header-v3 .search.dropdown"));
			$(".mega-menu .sub-menu").addClass("dropdown-menu");
			
			$(".header-v3 .menu-top li.level-1 .menu-level2").addClass("dropdown-menu");
		}else{
			
			$(".header-v3 .menu-top li.level-1 .menu-level2").removeClass("dropdown-menu");
			$(".mega-menu .sub-menu").removeClass("dropdown-menu");
			$(".ver-2 .forcefullwidth_wrapper_tp_banner").before($(".mega-menu.mega-menu-v2 "));
			menu_top_header3.insertAfter($(".header-v3 .header-top"));
		}
		$("#googleMap").css({"height": $(".contact-form").innerHeight()+"px"});
	});

	$('.owl-controls .owl-prev').html('<i class="fa fa-angle-left"></i>');
	$('.owl-controls .owl-next').html('<i class="fa fa-angle-right"></i>');
	// Click to Hover
	$('.dropdown').hover(function() {
	  $(this).find('.dropdown-menu').stop(true, true).delay(200).fadeIn(500);
	  $(this).toggleClass("active");
	}, function() {
	  $(this).find('.dropdown-menu').stop(true, true).delay(200).fadeOut(500);
	  $(this).toggleClass("active");
	});
	
	// Click Icon Menu Mobile
	$(".icon-menu-mobile").click(function(){
		$(".navbar-nav").slideToggle();
		$(this).toggleClass("active");
	});
	$(".header-v3 .icon-menu-mobile").click(function(){
		menu_top_header3.slideToggle();
	});
	$('li:has(ul)').addClass('hassub');
	$('li:has(img)').addClass('images');
	$(".mega-menu ul li a").after('<i class="fa fa-plus"></i>');
  	$(".mega-menu ul li h4").after('<i class="fa fa-plus"></i>');

	$(".featured-product ul.tabs").each(function(){
		$(this).insertAfter($(this).parent().prev().children("p"));
	});

	$(".ordering .list").click(function(){
		$(this).toggleClass("active");
		$(".products").addClass("list-item");
		$(".ordering .col").removeClass("active");
	});
	$(".ordering .col").click(function(){
		$(this).toggleClass("active");
		$(".products").removeClass("list-item");
		$(".ordering .list").removeClass("active");
	});

	$("ul.product-categories li.hassub a").after('<i class="fa fa-plus"></i>');
	$("ul li.hassub i").click(function(){
		$(this).next().slideToggle();
		$(this).toggleClass("active");
		$(this).parent().toggleClass("active");
	});
	$("#header .fa-bars").click(function(){
		$(".megamenu-v2").addClass("show-ef");
	});
	
	$(".megamenu-v2 .fa-times").click(function(){
		$(".megamenu-v2").removeClass("show-ef");
	});
	$(".carousel-control.right").html('<i class="fa fa-angle-right"></i>');
	$(".carousel-control.left").html('<i class="fa fa-angle-left"></i>');
	// googleMap
	// End google map
	/* event more-views click see big image. */
	$("ul.tabs li:first").addClass("active");
  	//
});

function revolutionSlider_4() {
	$(".slider-v2 .tp-banner").show().revolution({
		dottedOverlay:"none",      
        
        
           
        	startheight:800,  
      	
        delay:9000,
        startwidth:1800,
        hideThumbs:10,
        fullWidth:"on",
        forceFullWidth:"on",
		navigation: {
			keyboardNavigation:"off",
			keyboard_direction: "horizontal",
			mouseScrollNavigation:"off",
			onHoverStop:"on",
			touch:{
				touchenabled:"on",
				swipe_threshold: 75,
				swipe_min_touches: 50,
				swipe_direction: "horizontal",
				drag_block_vertical: false
			}
			,
			arrows: {
				enable:false,
			}
		}
	});
}


